module.exports = __webpack_public_path__ + "img/introduce-2.efd6dbdd.png";